import React, { useState, useEffect } from 'react';
import auth from '@react-native-firebase/auth';
import { connect } from 'react-redux';
import {
  LoadingModal,
  InfluencerWithSlotsScreen,
  useInfluencerData,
  clearDeepLinkParams,
  InfluencerNoScheduleScreen,
} from 'fitbeat.react-native-components';
import { InfluencerInviteScreenContainer } from './InfluencerInviteScreen';

export const InfluencerContainerComponent = ({
  navigation,
  clearDeepLinkParamsForInfluencerId,
}) => {
  const influencerId = navigation.getParam('influencerId');
  const screenFocussed = true;
  const {
    influencerBookings,
    influencerName,
    isLoadingBookings,
    avatar,
    isLoadingAvatar,
    landingPage,
    personalisedHeader,
  } = useInfluencerData(influencerId, screenFocussed);

  const hasBookings = influencerBookings.length > 0;
  const showLoadingModal = isLoadingBookings || isLoadingAvatar;
  const hasFetchedBookings = !isLoadingBookings;
  const [showNoScheduleScreen, setShowNoScheduleScreen] = useState(false);
  const shouldShowScheduleScreen = hasFetchedBookings && hasBookings;

  useEffect(() => {
    const isUserLoggedIn = !!auth().currentUser;
    const shouldShowNoScheduleScreen =
      isUserLoggedIn && hasFetchedBookings && !hasBookings;
    if (shouldShowNoScheduleScreen) {
      clearDeepLinkParamsForInfluencerId();
      setShowNoScheduleScreen(true);
    }
  }, [auth().currentUser, isLoadingBookings]);

  if (showLoadingModal) {
    return (
      <div className='influencer-container'>
        <LoadingModal isLoading={showLoadingModal} />
      </div>
    );
  }

  if (showNoScheduleScreen) {
    return (
      <div className='influencer-container'>
        <InfluencerNoScheduleScreen
          avatar={avatar}
          influencerName={influencerName}
          navigation={navigation}
        />
      </div>
    );
  }

  if (shouldShowScheduleScreen) {
    return (
      <InfluencerWithSlotsScreen
        influencerBookings={influencerBookings}
        influencerId={influencerId}
        influencerName={influencerName}
        avatar={avatar}
      />
    );
  }

  return (
    <InfluencerInviteScreenContainer
      influencerName={influencerName}
      navigation={navigation}
      influencerId={influencerId}
      avatar={avatar}
      landingPage={landingPage}
      personalisedHeader={personalisedHeader}
    />
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    clearDeepLinkParamsForInfluencerId: () =>
      dispatch(clearDeepLinkParams(['influencerId'])),
  };
};

export const InfluencerContainer = connect(
  null,
  mapDispatchToProps,
)(InfluencerContainerComponent);
